module.exports = __webpack_public_path__ + "img/apple-store.3778f83b.png";